import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  selectIsPackageSearcherEnabled,
  selectIsFlightSearcherEnabled,
  selectFirstActiveRoute,
} from 'legacyfrontend/redux/selectors/application-selectors';
import { ROUTE_KEYS } from 'legacyfrontend/constants';

const { BUSCAR_X_PAQUETES, BUSCAR_X_VUELOS, PAQUETES, PAQUETE } = ROUTE_KEYS;

export const useSearcherValidation = () => {
  const history = useHistory();
  const location = useLocation();

  const isPackageSearcherEnabled = useSelector(selectIsPackageSearcherEnabled);
  const isFlightSearcherEnabled = useSelector(selectIsFlightSearcherEnabled);
  const firstActiveRoute = useSelector(selectFirstActiveRoute);

  const isSearchRoute =
    location.pathname.includes(BUSCAR_X_PAQUETES) || location.pathname.includes(BUSCAR_X_VUELOS);

  useEffect(() => {
    const currentPath = location.pathname;

    if (
      currentPath.includes(BUSCAR_X_PAQUETES) ||
      currentPath.includes(PAQUETES) ||
      currentPath.includes(PAQUETE)
    ) {
      if (!isPackageSearcherEnabled) {
        history.replace(firstActiveRoute);
        return;
      }
    }

    if (currentPath.includes(BUSCAR_X_VUELOS)) {
      if (!isFlightSearcherEnabled) {
        history.replace(firstActiveRoute);
        return;
      }
    }
  }, [
    location.pathname,
    isPackageSearcherEnabled,
    isFlightSearcherEnabled,
    firstActiveRoute,
    history,
  ]);

  return {
    isPackageSearcherEnabled,
    isFlightSearcherEnabled,
    isSearchRoute,
    firstActiveRoute,
  };
};

export default useSearcherValidation;
